import { render, staticRenderFns } from "./RelatorioDeAssinaturaHolerite.vue?vue&type=template&id=5bd023b6"
import script from "./RelatorioDeAssinaturaHolerite.vue?vue&type=script&lang=js"
export * from "./RelatorioDeAssinaturaHolerite.vue?vue&type=script&lang=js"
import style0 from "./RelatorioDeAssinaturaHolerite.vue?vue&type=style&index=0&id=5bd023b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports